import { css } from '@emotion/react';

export const datePickerCalendar = css`
  border: 0;
`;

export const datePickerPopover = css`
  & .MuiPopover-paper {
    // FIX: This should use shadow[100] but it doesn't look quite right
    box-shadow: 0px 1px 16px rgba(80, 100, 130, 0.17);
  }
`;
